import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import GoldenSaleCard from "./GoldenSaleCard";

class GoldenSale extends React.Component {
  render() {
    const { link } = this.props;
    console.log(link);
    return (
      <div className={`${"specialSection"} ${"goldenSale"} `}>
        <div className={"content"}>
          <img
            src="public/assets/sale.svg"
            alt="SaleMarker"
            className={"saleMarker"}
          />
          <div className={"goldenImgSale"}>
            <div className={"img_conttainer"}>
              <img src={this.props.img} />
              <a href={`${link}`} className={"imgLink"}>
                <span>مشاهده همه</span>
                <i className={`icon-chevron-left`} />
              </a>
            </div>
          </div>
          <div className={"products"}>
            <div className={"sliderRows"}>
              <div className={"sliderRow"}>
                <Swiper
                  modules={[Autoplay]}
                  slidesPerView={1.5}
                  spaceBetween={16}
                  loop={true}
                  autoplay={{
                    delay: 1000,
                    disableOnInteraction: false,
                  }}
                  className="mySwiper"
                >
                  {this.props.data.map((item) => (
                    <SwiperSlide key={item.id} className={"goldenSlider"}>
                      <GoldenSaleCard data={item} key={item.id} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GoldenSale;
